var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 9.5V8h1.5v1.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.75 2.25H12c.966 0 1.75.784 1.75 1.75v8A1.75 1.75 0 0 1 12 13.75H4A1.75 1.75 0 0 1 2.25 12V4c0-.966.784-1.75 1.75-1.75h.25V1h1.5v1.25h4.5V1h1.5zM4 3.75a.25.25 0 0 0-.25.25v1.25h8.5V4a.25.25 0 0 0-.25-.25zM3.75 12V6.75h8.5V12a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;